import React, { useEffect } from 'react';
import { shape, string } from 'prop-types';
import {
  useHelmet, TitleTag, MetaTag, LinkTag
} from '@thd-nucleus/thd-helmet';

const shopByRoomMetadataHandler = ({ props }) => {
  const { data } = props;
  const { title, canonicalUrl, metaDescription, imageUrl } = data;
  const seoTitle = `${title} - The Home Depot`;
  const canonical = canonicalUrl;
  const description = metaDescription;
  const heroUrl = imageUrl;

  const tags = [
    new TitleTag(seoTitle),
    new MetaTag({ name: 'description', content: description, id: 'description' }),
    new MetaTag({ property: 'og:title', content: seoTitle, id: 'ogTitle' }),
    new MetaTag({ property: 'og:description', content: description, id: 'ogDescription' }),
    new MetaTag({ property: 'og:image', content: heroUrl, id: 'ogImage' }),
    new MetaTag({ property: 'og:url', content: canonical, id: 'ogUrl' }),
    new MetaTag({ property: 'og:type', content: 'product', id: 'ogType' }),
    new MetaTag({ property: 'og:site_name', content: 'The Home Depot', id: 'ogSiteName' }),
    new MetaTag({ property: 'fb:admins', content: '100005416960152', id: 'fbAdmins' }),
    new LinkTag({ rel: 'canonical', href: canonical, id: 'canonical' }),
  ];
  return tags;
};

export const ShopByRoomMetadata = (props) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('shop-by-room-metadata.ready'); }, []);
  useHelmet('shopByRoomMetadataHandler', { props }, shopByRoomMetadataHandler, [props]);
  return null;
};

ShopByRoomMetadata.displayName = 'ShopByRoomMetadata';
